import { call, put } from "redux-saga/effects";
import {
  fetchProductPlanogramMappingSuccess,
  importFileSuccess,
  importFileFailed,
} from "./actions";
import { showErrorNotification } from "src/util/notifications";
import api from "src/util/api";
import { PRODUCT_PLANOGRAM_URL } from "src/util/constants/api.constants";

export function* fetchProductPlanogramMapping({ payload }: any): Generator {
  try {
    let url = PRODUCT_PLANOGRAM_URL.PRODUCT_PLANOGRAM_LIST + "/" + payload;
    const data: any = yield call(api.get, url);
    yield put(fetchProductPlanogramMappingSuccess(data));
  } catch (e: any) {
    showErrorNotification(null, e);
  }
}

export function saveProductPlanogramMapping(payload: any) {
  let url = `${PRODUCT_PLANOGRAM_URL.PRODUCT_PLANOGRAM_UPDATE_INSERT}`;
  return api.post(url, payload);
}

export function getProductPlanogramMapping() {
  let url = `${PRODUCT_PLANOGRAM_URL.PRODUCT_PLANOGRAM_LIST}`;
  return api.get(url);
}

export function getProductPlanogram(payload: any) {
  let url = PRODUCT_PLANOGRAM_URL.PRODUCT_PLANOGRAM_BY_ID + payload;
  return api.get(url);
}

export function getProductCostByUPC(payload: any) {
  let url = PRODUCT_PLANOGRAM_URL.PRODUCT_COST_BY_UPCCODE + payload;
  return api.get(url);
}

export function* importFileProductPlanogram({
  payload,
  actionType,
}: any): Generator {
  try {
    let url = `${PRODUCT_PLANOGRAM_URL.PRODUCT_PLANOGRAM_IMPORT_FILE}`;
    const formdata = new FormData();
    formdata.append("file", payload.file);
    formdata.append("AssortmentName", payload.params.assortmentName);
    formdata.append("IsAutoCreateAssortment", payload.params.isAssortment);
    formdata.append("CreatedBy", payload.params.userName);
    formdata.append("IsBulkUpdate", payload.params.IsBulkUpdate);
    const data: any = yield call(api.post, url, formdata);
    yield put(importFileSuccess(data));
  } catch (e: any) {
    yield put(importFileFailed(e.response?.data));
    showErrorNotification(e.response?.data?.error?.messages[0]);
  }
}

export function deletePPItems(payload: any) {
  let url =
    PRODUCT_PLANOGRAM_URL.DELETE_PP_ITEM + payload.Id + "/" + payload.userName;
  return api.delete(url, payload);
}

export function fetchAssortments(payload: any) {
  let url = PRODUCT_PLANOGRAM_URL.GET_ASSORTMENTS + payload;
  return api.get(url);
}
